

import { Component, Mixins, Prop } from 'vue-property-decorator';
import Chart from 'chart.js';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import { Scatter, mixins } from 'vue-chartjs';
import { MemberDatas } from '@/@types/LibraryComponent';

@Component({
  components: {
    ChartJsPluginDataLabels,
  },
})
export default class Bar extends Mixins(Scatter) {
  @Prop(String) public height!: string;
  // グラフ用のデータ
  private maxXPoint: number = 16; // DBから取ってくる時に取得するイメージ
  private maxYPoint: number = 26; // DBから取ってくる時に取得するイメージ
  // dummy
  private memberDatas: Array<MemberDatas> = [
    {
      x: '0',
      y: '9',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'php',
      memberLink: 'hoge.com',
    },
    {
      x: '2',
      y: '7',
      memberName: '小嶋健太',
      memberImg: 'member_image02.jpg',
      memberSkill: 'shell',
      memberLink: 'fuga.com',
    },
    {
      x: '1',
      y: '5',
      memberName: '岡崎次郎',
      memberImg: 'member_image03.jpg',
      memberSkill: 'java',
      memberLink: 'foo.com',
    },
    {
      x: '4',
      y: '22',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '15',
      y: '1',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '8',
      y: '8',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '9',
      y: '16',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '4',
      y: '3',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '7',
      y: '17',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '16',
      y: '12',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '14',
      y: '10',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '3',
      y: '9',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '13',
      y: '2',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
    {
      x: '5',
      y: '4',
      memberName: '原田圭佑',
      memberImg: 'member_image01.jpg',
      memberSkill: 'html, css, php, node, vue, python, linux',
      memberLink: 'hoge.com',
    },
  ];
  private chartData: Chart.ChartData = {
    labels: ['ベロシティ', '資本効率'],
    datasets: [
      {
        label: 'Group1',
        type: 'scatter',
        data: this.memberDatas,
        backgroundColor: '#00bcd4',
        pointRadius: 2,
        pointHoverRadius: 4,
        pointHitRadius: 6,
        hoverRadius: 1,
      },
    ],
  };

  private chartOptions: Chart.ChartOptions = {
    // 凡例の位置
    legend: {
      display: false,
    },
    showAllTooltips: true,
    // レスポンシブ（true だとサイズ自動調整）
    responsive: true,
    tooltips: {
      // キャンバス上のツールチップを無効にする
      enabled: false,
      callbacks: {
        title: (tooltipItem, data) => {
          return 'メンバー詳細';
        },
        label: (tooltipItem, data) => {
          return this.memberDatas;
        },
      },
      custom(tooltipModel) {
        // ツールチップ要素
        let tooltipElement = document.getElementById('chartjs-tooltip');

        // 最初のレンダリング時に要素を作成する
        if (!tooltipElement) {
          tooltipElement = document.createElement('div');
          tooltipElement.id = 'chartjs-tooltip';
          tooltipElement.innerHTML = '<table></table>';
          document.body.appendChild(tooltipElement);
        }

        // ツールチップがない場合は非表示にします
        if (tooltipModel.opacity === 0) {
          tooltipElement.style.opacity = '0';
          return;
        }

        // キャレット(ツールチップが指し示すもの)の位置を設定する
        tooltipElement.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
          tooltipElement.classList.add(tooltipModel.yAlign);
        } else {
          tooltipElement.classList.add('no-transform');
        }

        function getBody(bodyItem: Chart.ChartTooltipModelBody) {
          return bodyItem.lines;
        }

        // カスタムツールチップ内のテキストを設定する
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || [];
          const bodyLines = tooltipModel.body.map(getBody);
          let innerHtml = '<thead>';

          titleLines.forEach((title) => {
            innerHtml += '<tr><th>' + title + '</th></tr>';
          });
          innerHtml += '</thead><tbody>';

          const memberDetailArticles = [];
          if (tooltipModel.dataPoints[0].index) {
            memberDetailArticles[0] = bodyLines[0][tooltipModel.dataPoints[0].index].memberName;
            memberDetailArticles[1] = 'ベロシティ:' + bodyLines[0][tooltipModel.dataPoints[0].index].x;
            memberDetailArticles[2] = '効率:' + bodyLines[0][tooltipModel.dataPoints[0].index].y;
            memberDetailArticles[3] = bodyLines[0][tooltipModel.dataPoints[0].index].memberImg;
            // memberDetailArticles[4] = 'スキル:' + bodyLines[0][tooltipModel.dataPoints[0].index].memberSkill;
            // memberDetailArticles[5] = bodyLines[0][tooltipModel.dataPoints[0].index].memberLink;
          }

          memberDetailArticles.forEach((article, index) => {
            if (index === 0) {
              const name = article;
              article = '<div class="row pt-1">';
              article += '<div class="d-flex align-center col col-1">';
              article +=
                '<img src="/img/test.112a7b5c.jpeg" style="width: 32px;height: 32px;border-radius: 16px;"></div>';
              article += '<div class="d-flex align-center ml-16 col" style="width: 100%;">';
              article +=
                '<span style="display: block;margin-left:16px;margin-top: 5px;">' +
                name +
                '</span></div></div></div>';
            }
            innerHtml += '<tr><td>' + article + '</td></tr>';
          });
          innerHtml += '</tbody>';

          const tableRoot = tooltipElement.querySelector('table');
          tableRoot!.innerHTML = innerHtml;
        }

        // `this` はツールチップ全体です
        const position = this._chart.canvas.getBoundingClientRect();

        // ツールチップの配置cssデザインはscssで
        tooltipElement.style.opacity = '1';
        tooltipElement.style.position = 'absolute';
        tooltipElement.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipElement.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipElement.style.fontFamily = tooltipModel._bodyFontFamily;
        tooltipElement.style.fontSize = tooltipModel.bodyFontSize.toString();
        tooltipElement.style.fontStyle = tooltipModel._bodyFontStyle;
        tooltipElement.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        tooltipElement.style.pointerEvents = 'none';
      },
    },
    // hover時のアニメーションの表示切替
    hover: {
      mode: 'nearest' || 'point',
      intersect: true,
    },
    scales: {
      // X軸
      xAxes: [
        {
          // グリッドラインの表示
          gridLines: {
            drawBorder: true,
            display: true,
            color: 'rgba(0, 0, 0, 0)',
          },
          scaleLabel: {
            display: true,
            labelString: 'ベロシティ',
          },
          // 目盛り
          ticks: {
            display: false,
            min: 0,
            max: this.maxXPoint + Math.floor(this.maxXPoint / 10),
            stepSize: Math.floor(this.maxXPoint / 10),
            maxTicksLimit: 11,
          },
        },
      ],
      // Y軸
      yAxes: [
        {
          gridLines: {
            drawBorder: true,
            display: true,
            color: 'rgba(0, 0, 0, 0)',
          },
          scaleLabel: {
            display: true,
            labelString: '効率',
          },
          // 目盛り
          ticks: {
            display: false,
            min: 0,
            max: this.maxYPoint + Math.floor(this.maxYPoint / 10),
            stepSize: Math.floor(this.maxYPoint / 10),
            maxTicksLimit: 11,
          },
        },
      ],
    },
    // 散布の座標値
    plugins: {
      datalabels: {
        font: {
          size: 0,
        },
      },
    },
    events: ['click', 'mousemove'],
    onClick: (event, elements) => {
      function sleep(waitSec: number, callbackFunc: void) {
        let spanedSec = 0;
        const waitFunc = () => {
          spanedSec++;
          if (spanedSec >= waitSec) {
            // if (callbackFunc) callbackFunc();
            return;
          }
          clearTimeout(id);
          id = setTimeout(waitFunc, 100);
        };
        let id = setTimeout(waitFunc, 100);
      }
      const data = this.memberDatas;
      const element = elements;
      document.getElementById('showMember')!.click();
      if (element) {
        sleep(
          2,
          ((data2, element2) => {
            const nameElement = document.getElementById('memberDetailName');
            const imageElement = document.getElementById('memberDetailImg');
            const skillElement = document.getElementById('memberDetailSkill');
            const linkElement = document.getElementById('memberDetailLink');
            if (nameElement) {
              nameElement.textContent = data2[element2[0]._index].memberName;
            }
            if (imageElement) {
              imageElement.textContent = data2[element2[0]._index].memberImg;
            }
            if (skillElement) {
              skillElement.textContent = data2[element2[0]._index].memberSkill;
            }
            if (linkElement) {
              linkElement.textContent = data2[element2[0]._index].memberLink;
            }
          })(data, element)
        );
      }
      return;
    },
  };

  public mounted(): void {
    // グラフを描画
    this.renderChart(this.chartData, this.chartOptions);
  }
}
